<template>
  <div class="buypileh5-Container" >
    <div class="bg">
     <img  class="bg-item" v-lazy="bg"  alt="" >
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      bg:'https://frontend-mam.oss-cn-hangzhou.aliyuncs.com/images/2021-12-690-100.jpg?tem=' + Date.now(),
     
    }
  },
  created(){
  },
  methods:{}
   
}
</script>

<style lang="less" scoped> 
.buypileh5-Container{
    position: relative;
   .bg{
       width: 100%;
       position: absolute;
       left: 0;
       top: 0;
       display: flex;
       flex-direction: column;
       .bg-item{
        width: 100%;
       }
   }
  .area{
      position: relative;
      width: 100%;
      height: 72rem;
  }

  .qrcode{
      position: absolute;
      width: 3.80rem;
      left: 1.85rem;
      top:52.80rem;
      z-index: 1111;
      opacity: 0;
      background-color: black;
  }
}
</style>